export default __webpack_public_path__ + "static/media/Group1146.b27e2039.svg";